import { render, staticRenderFns } from "./BaseBalancePageCard.vue?vue&type=template&id=019150ec&scoped=true&"
import script from "./BaseBalancePageCard.vue?vue&type=script&lang=js&"
export * from "./BaseBalancePageCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseBalancePageCard.vue?vue&type=style&index=0&id=019150ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019150ec",
  null
  
)

export default component.exports